import styled from 'styled-components';

import { SIZE, LIGHT_BLUE, WHITE, BORDER } from '../../const';

export const StyledCategoryBlock = styled.div`
    max-width: 1141px;
    margin: 44px auto 0;
    position: relative;

    @media ${SIZE.laptopL} { 
        margin: 40px auto;
    }

    @media ${SIZE.tablet} { 
        margin: ${props => props.isJobPostingPage ? '8.5px 0 0' : '43px 0 0'};
    }

    .categoryTitle {
        font-weight: bold;
        font-size: 28px;
        line-height: 52px;
        color: ${LIGHT_BLUE};
        background: ${WHITE};
        position: absolute;
        margin-top: -29px;
        padding: 0 10px 0 15px;
    }

    .divider {
        border: ${BORDER}
        margin-right: 30px;

        @media ${SIZE.tablet} { 
            display: none;
        }
    }

    .job-posting-banner-wrap {
        padding: 0 20px;
    }
`;
